import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import { Container, LinkButton } from './reward-selection-link.styled';

export const RewardSelectionLink: FC<{ onClick: () => void }> = ({ onClick }) => {
  const { formatMessage } = useIntl();
  return (
    <Container data-testid="reward-selection-link">
      <LinkButton onClick={onClick}>
        {formatMessage({ id: 'rewardsManagementChangeRewardLevel' })}
      </LinkButton>
    </Container>
  );
};
